var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ScissorArea',{staticClass:"w-full h-min70 xl:h-min60",staticStyle:{"z-index":"2"}},[_c('div',{staticClass:"full",attrs:{"slot":"dom"},slot:"dom"}),_c('ChurchScene',{attrs:{"slot":"o3d"},slot:"o3d"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }